<template>
  <d-list-group flush>
    <d-list-group-item class="p-3">
      <d-form @submit.prevent="save" :validated="hasErrors">
        <d-form-row class="mb-2">
          <!-- Nome -->
          <d-col md="8" class="form-group">
            <label for="label">Nome do template</label>
            <d-form-input
              :state="hasErrorFiled('name')"
              type="text"
              placeholder="Nome do template"
              v-model="model.name"
            />
            <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
          </d-col>
          <!-- Tipo -->
          <d-col md="4" class="form-group">
            <label for="label">Tipo de projeto</label>
            <d-select
              v-model="model.type_id"
              :state="hasErrorFiled('type_id')"
              @change="onTypeChange"
            >
              <option :value="option.id" v-for="(option, index) in typeOptions" :key="index">{{ option.name }}</option>
            </d-select>
            <d-form-invalid-feedback>Tipo é obrigatório</d-form-invalid-feedback>
          </d-col>
        </d-form-row>

        <d-form-row>
          <d-col cols="12" class="form-group" v-if="model.groups">
            <template-groups-form
              ref="group"
              :groups.sync="model.groups"
              :type-id="model.type_id"
              :state="groupsEmptyRow ? 'invalid' : 'valid'"
            />
          </d-col>
        </d-form-row>

        <d-button type="submit" class="btn-accent float-right mr-2">Salvar</d-button>

      </d-form>
    </d-list-group-item>
    <contractual-items-select-modal/>
    <single-option-select-modal/>
    <import-modals/>
  </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import TemplateGroupsForm from '_modules/quotation/components/TemplateGroupsForm.vue';
import ContractualItemsSelectModal from '_modules/quotation/components/modal/ContractualItemsSelectModal.vue';
import SingleOptionSelectModal from '_modules/quotation/components/modal/SingleOptionSelectModal.vue';
import ImportModals from '_modules/quotation/components/ImportModals.vue';
import MixinValidateForm from '_common/mixins/ValidateForm';
import QuotationService from '_services/rest/modules/quotation';
import QuotationActions from './QuotationActions';
import {
  TYPE_OPTIONS,
  TEMPLATE_ROW,
  TEMPLATE_MODEL,
  _LOAD_TEMPLATE_MODEL_,
  OPTIONS_CONFIRMATION_MODAL,
} from './QuotationModel';
import { applyTypeForwardToGroups, hasLoadedTypeOptions } from './installmentsPlan';

export default {
  name: 'template-form',
  mixins: [MixinValidateForm, QuotationActions],
  components: {
    TemplateGroupsForm,
    ContractualItemsSelectModal,
    SingleOptionSelectModal,
    ImportModals,
  },
  data() {
    return {
      type: 'delete',
      model: cloneDeep(TEMPLATE_MODEL),
      confirmation: OPTIONS_CONFIRMATION_MODAL,
      groupsEmptyRow: null,
      errors: {
        name: { required: false },
        type_id: { required: false },
      },
    };
  },
  computed: {
    isCreate() {
      return !this.$route.params.templateId && !this.model.id;
    },
    typeOptions() {
      const { typeOptions } = this.$store.state.quotation;
      if (typeOptions && typeOptions.length) {
        return typeOptions;
      }
      return TYPE_OPTIONS;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getTypeOptions',
    ]),
    ensureTypeOptions() {
      const { typeOptions } = this.$store.state.quotation;
      if (hasLoadedTypeOptions(typeOptions)) {
        return Promise.resolve(typeOptions);
      }
      return this.getTypeOptions();
    },
    seedTypeForwardInstallments() {
      const { typeOptions } = this.$store.state.quotation;
      if (!this.model.type_id || !Array.isArray(this.model.groups) || !hasLoadedTypeOptions(typeOptions)) {
        return;
      }
      applyTypeForwardToGroups(
        this.model.groups,
        typeOptions,
        this.model.type_id,
      );
    },
    seedTypeForwardInstallmentsOnCreate() {
      if (!this.isCreate) {
        return Promise.resolve();
      }
      return this.ensureTypeOptions().then(() => {
        this.seedTypeForwardInstallments();
      });
    },
    onTypeChange() {
      this.seedTypeForwardInstallmentsOnCreate();
    },
    reorder(group) {
      group.rows.forEach((row, index) => {
        row.order = index;
        return row;
      });
    },
    saveCreatedBy() {
      if (!this.model.created_by && !this.model.id) {
        const { id } = this.$store.state.user.user;
        this.model.created_by = id;
      }
    },
    cleanEmptyRows() {
      this.groupsEmptyRow = false;
      this.model.groups = this.model.groups.map(group => {
        group.rows = group.rows.filter(row => row.variation_id);
        this.reorder(group);
        if (group.rows.length === 0) {
          this.groupsEmptyRow = true;
          group.rows.push(cloneDeep(TEMPLATE_ROW));
        }
        return group;
      });
    },
    getTypes() {
      if (!this.$store.state.quotation.typeOptions) {
        this.setToggle({ type: 'progress', bool: true });
        return this.getTypeOptions()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
            this.seedTypeForwardInstallmentsOnCreate();
          });
      }
      return this.seedTypeForwardInstallmentsOnCreate();
    },
    getQuotationTemplate(templateId) {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.getTemplateById(templateId)
        .then(response => {
          Events.$emit(_LOAD_TEMPLATE_MODEL_, response);
        })
        .catch(error => {
          this.activeAlert({
            message: error.message || 'Erro ao carregar o Template',
            theme: 'danger',
          });
        });
      this.setToggle({ type: 'progress', bool: false });
    },
    save() {
      const checkGroups = this.$refs.group.validateAll();
      if (this.checkForm() && checkGroups) {
        this.seedTypeForwardInstallmentsOnCreate()
          .then(() => {
            this.cleanEmptyRows();
            this.saveCreatedBy();

            return QuotationService.saveTemplate(this.model)
              .then(response => {
                this.activeAlert({ message: 'Template salvo com sucesso', theme: 'success' });
                if (!this.$route.params.templateId) {
                  this.$router.push({ name: 'admin-quotation-template-edit', params: { templateId: response.id } });
                }
              })
              .catch(() => {
                this.activeAlert({ message: 'Erro ao salvar o Template', theme: 'danger' });
              });
          });
      } else {
        this.activeAlert({ message: 'Verifique os campos obrigatórios', theme: 'danger' });
      }
    },
  },
  mounted() {
    this.getTypes();
    this.model = cloneDeep(TEMPLATE_MODEL);
    if (this.$route.params.templateId) {
      this.getQuotationTemplate(this.$route.params.templateId);
    }
    Events.$emit('sidebarVisible', false);
    Events.$on(_LOAD_TEMPLATE_MODEL_, newValue => {
      this.model = { ...newValue };
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.table {
  border: 1px solid #dee2e6;
  tr th {
    border-bottom: 0;
  }
  td {
    vertical-align: middle;
  }
}
</style>
